<template>
  <div class="grid">
    <div class="grid-content">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">{{$t('tableUsersCol1')}}</th>
            <th scope="col">{{$t('tableUsersCol2')}}</th>
            <th scope="col">{{$t('tableUsersCol3')}}</th>
            <th scope="col">{{$t('tableUsersCol4')}}</th>

            <th scope="col">{{$t('tableUsersCol5')}}</th>
            <th scope="col">{{$t('tableUsersCol6')}}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(datos, index) in pagination[page]" :key="datos.id">
            <th scope="row">{{index + 1}}</th>
            <td>{{datos.brief_desc}}</td>
            <td>{{datos.user.firstname}}</td>
            <td>{{datos.user.lastname}}</td>
            <td>{{datos.user.email}}</td>

            <td>{{getTime(datos.notBefore)}}</td>
            <td>{{getTime(datos.notAfter)}}</td>
            <td>
              <button class="delete-btn" type="button" @click="deleteKey(datos)"></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <nav class="grid-content bottom--pagination">
      <ul class="pagination justify-content-center">
        <li class="page-item">
          <button class="page-link" :disabled="disabledBack" @click="back()">{{$t('tableUsersBack')}}</button>
        </li>
        <li class="page-item" v-for="(page, index) in pagination" :key="page.id">
          <a class="page-link" @click="changePage(index)" href="#">{{index + 1}}</a>
        </li>
        <li v-if="empty" class="page-item">
          <a class="page-link" href="#">1</a>
        </li>
        <li class="page-item">
          <button type="button" :disabled="disabledNext" @click="next()" class="page-link">{{$t('tableUsersNext')}}</button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
  data() {
    return {
      datosLocker: [],
      pagination: [],
      page: 0,
      hidePrevious: false,
      hideNext: false,
      empty: true,
      disabledNext: false,
      disabledBack: false
    };
  },
  methods: {
    loadDatos() {
      // console.log("Entra por aquí");
      var login = JSON.parse(localStorage.getItem("session"));

      this.axios
        .get("https://lightkey.es:3000/lightkey/api/owner/users", {
          headers: { authorization: login.session }
        })
        .then(response => {
          // console.log({ response });

          response.data.forEach(dato => {
            // console.log(dato);
            this.datosLocker.push(dato);
          });
        })
        .then(resp => {
          // console.log("He pasado por aqui");
          this.pagination = this.getPagination(this.datosLocker, 12);

          this.pagination.length == 0
            ? (this.empty = true)
            : (this.empty = false);

          if (this.pagination.length <= 1) {
            this.disabledNext = true;
            this.disabledBack = true;
          } else {
            this.disabledNext = false;
            this.disabledBack = false;
          }

          this.page == 0 ? (this.disabledBack = true) : null;
        })
        .catch(err => {
          // console.error("Ha petado de nuevo hulio", err);
          this.$router.replace("/");
        });
    },
    getPagination(array, number) {
      let pagination = [];
      let userPerPage = [];

      array.forEach(users => {
        userPerPage.push(users);
        if (userPerPage.length >= number) {
          pagination.push(userPerPage);
          userPerPage = [];
        }
      });
      if (userPerPage.length > 0) {
        pagination.push(userPerPage);
      }
      return pagination;
    },
    getTime(dateTime) {
      var fecha = new Date(dateTime);
      return `${fecha.getDate()}/${fecha.getMonth() + 1}/${fecha.getFullYear()} ${((fecha.getHours()) % 24 < 10 ? "0" : "") +
        ((fecha.getHours()) % 24)}:${((fecha.getMinutes()) % 60 < 10
        ? "0"
        : "") +
        ((fecha.getMinutes()) % 60)}`;
    },
    deleteKey(user) {
      var login = JSON.parse(localStorage.getItem("session"));
      // console.log({ login });
      // console.log({ user });
      var popup={};
      switch(i18n.locale){
          case "en":
              popup.title=i18n.messages.en.deletingKeyTitle;
              popup.text=i18n.messages.en.deletingKeyText;
              popup.confirmButton=i18n.messages.en.deletingKeyConfirmButton;
              popup.cancelButton=i18n.messages.en.logoutTextCancelOption;
              popup.confirm=i18n.messages.en.deletingKeyOk;
              break;
          case "es":
              popup.title=i18n.messages.es.deletingKeyTitle;
              popup.text=i18n.messages.es.deletingKeyText;
              popup.confirmButton=i18n.messages.es.deletingKeyConfirmButton;
              popup.cancelButton=i18n.messages.es.logoutTextCancelOption;
              popup.confirm=i18n.messages.es.deletingKeyOk;
              break;
          case "de":
              popup.title=i18n.messages.de.deletingKeyTitle;
              popup.text=i18n.messages.de.deletingKeyText;
              popup.confirmButton=i18n.messages.de.deletingKeyConfirmButton;
              popup.cancelButton=i18n.messages.de.logoutTextCancelOption;
              popup.confirm=i18n.messages.de.deletingKeyOk;
              break;
        }
      this.$swal
        .fire({
          position: "top-center",
          title: popup.title,
          text: popup.text,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: popup.cancelButton,
          confirmButtonText: popup.confirmButton
        })
        .then(result => {
          if (result.value) {
            this.axios
              .delete("https://lightkey.es:3000/lightkey/api/keys", {
                data: user,
                headers: { authorization: login.session }
              })
              .then(response => {
                this.datosLocker = this.datosLocker.filter(
                  usr => usr.id != user.id
                );
                this.pagination = this.getPagination(this.datosLocker, 12);
                if (this.pagination.length == 0) {
                  this.empty = true;
                } else {
                  this.empty = false;
                }
                this.$swal.fire({
                  position: "top-end",
                  type: "success",
                  title: popup.confirm,
                  showConfirmButton: false,
                  timer: 1500
                });
              })
              .catch(err => {
                // console.error("Ha petado de nuevo hulio", err);
                this.$router.replace("/");
              });
          }
        });

      if (this.pagination.length <= 1) {
        this.disabledNext = true;
        this.page = 0;
        // console.log(this.page); 
      } else {
        this.disabledNext = false;
      }
    },
    getUserByPage() {
      return this.pagination[0];
    },
    changePage(numberOfPage) {
      this.page = numberOfPage;
      if (this.page == this.pagination.length - 1) {
        this.disabledNext = true;
      } else {
        this.disabledNext = false;
      }
      if (this.page == 0) {
        this.disabledBack = true;
      } else {
        this.disabledBack = false;
      }
    },
    next() {
      this.page++;
      if (this.page == this.pagination.length - 1) {
        // console.log("Verificando si se cumple");
        this.disabledNext = true;
      } else {
        this.disabledNext = false;
      }
      this.disabledBack = false;
    },
    back() {
      this.page--;
      if (this.page <= 0) {
        this.disabledBack = true;
      } else {
        this.disabledBack = false;
      }
      this.disabledNext = false;
    },
    setLanguage(){
      if(localStorage.getItem('language')){
        console.log(localStorage.getItem('language'));
        i18n.locale = localStorage.getItem('language'); 
      }else{
        console.log("No hay lenaguaje");
      }
    }
  },
  created() {
    this.loadDatos();
    this.setLanguage();
  },
  computed: {
    startDate() {
      this.datosLocker;
    }
  }
};
</script>

<style scoped >
.grid {
  display: grid;
  grid-template-columns: 1fr 1170px 1fr;
}

li {
  text-align: left;
}

.grid-content {
  grid-column: 2/3;
}

.delete-btn {
  border: none;
  background-color: unset;
  padding: 12px;
  background-image: url("../../../assets/delete_white.png");
  background-size: cover;
}

button:disabled {
  background-color: rgba(50, 50, 50, 0.6);
  color: white;
}

.bottom--pagination {
  position: absolute;
  top: 90vh;
  left: calc(50% - 100px);
}

@media(max-width:1160px){
  .grid{
    grid-template-columns: 1fr 99% 1fr;
    font-size: 75%;
  }
  .delete-btn {
    border: none;
    background-color: unset;
    padding: 10px;
    background-image: url("../../../assets/delete_white.png");
    background-size: cover;
  }
}

@media(max-width:768px){
  .grid{
    grid-template-columns: 1fr 99% 1fr;
    font-size: 45%;
  }
  .delete-btn {
    border: none;
    background-color: unset;
    padding: 8px;
    background-image: url("../../../assets/delete_white.png");
    background-size: cover;
  }
}

@media(max-width:480px){
  .grid{
    grid-template-columns: 1fr 99% 1fr;
    font-size: 25%;
  }
  .delete-btn {
    border: none;
    background-color: unset;
    padding: 4px;
    background-image: url("../../../assets/delete_white.png");
    background-size: cover;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/dashboard/children/Users.vue